import axios from 'axios';

// API configuration utility
// Use proxy in development to avoid CORS issues with cookies

const getApiUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  
  // In development, use the proxy configured in package.json
  return '/api';
};

export const API_URL = getApiUrl();

// Configure axios to send credentials with all requests
axios.defaults.withCredentials = true;

// Function to set auth token
export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

// For debugging
console.log('API_URL configured as:', API_URL);